var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84416 20.3126C9.09573 19.3738 10.0608 18.8166 10.9996 19.0682C11.9386 19.3198 12.4957 20.2848 12.2442 21.2237L10.9121 26.1952C10.7705 26.7233 10.2276 27.0367 9.69952 26.8953L8.21199 26.4966C7.68391 26.3552 7.37049 25.8123 7.51201 25.2842L8.84416 20.3126Z",
    fill: "#8E44EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3035 17.7616C15.9908 17.0743 17.1053 17.0743 17.7926 17.7616L21.5429 21.5118C21.9295 21.8984 21.9295 22.5253 21.5429 22.9119L20.454 24.0008C20.0673 24.3874 19.4405 24.3874 19.0539 24.0008L15.3035 20.2505C14.6163 19.5632 14.6163 18.4489 15.3035 17.7616Z",
    fill: "#8E44EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02604 14.4725C6.96494 14.2209 7.92998 14.7782 8.18155 15.717C8.43312 16.6559 7.87597 17.621 6.9371 17.8726L1.64506 19.2906C1.11693 19.4321 0.57407 19.1187 0.432555 18.5906L0.0339806 17.103C-0.107534 16.5749 0.205877 16.0321 0.734009 15.8906L6.02604 14.4725Z",
    fill: "#8E44EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7905 0.432566C17.3186 0.574081 17.632 1.11693 17.4906 1.64506L13.877 15.131C13.6254 16.0699 12.6604 16.627 11.7214 16.3756C10.7826 16.124 10.2254 15.1588 10.4769 14.22L14.0904 0.734021C14.2319 0.205889 14.7748 -0.107532 15.3029 0.0339777L16.7905 0.432566Z",
    fill: "#8E44EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5335 12.1326C24.6749 12.6607 24.3615 13.2036 23.8334 13.3452L18.6094 14.7448C17.6706 14.9964 16.7055 14.4392 16.454 13.5004C16.2024 12.5614 16.7595 11.5964 17.6984 11.3448L22.9224 9.94511C23.4505 9.80361 23.9934 10.117 24.1348 10.6451L24.5335 12.1326Z",
    fill: "#8E44EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18185 9.15093C9.86924 9.83826 9.86924 10.9525 9.18185 11.6399C8.49457 12.3272 7.38025 12.3272 6.69292 11.6399L0.493576 5.44055C0.106959 5.05394 0.106959 4.4271 0.493576 4.04048L1.58247 2.95158C1.96909 2.56497 2.59592 2.56497 2.98255 2.95158L9.18185 9.15093Z",
    fill: "#8E44EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.76d2c3dbd8cad668d6de37a276ce5d45.svg";
export { ForwardRef as ReactComponent };